import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Wraps content that should only be visible when the selected variant is sold out.
 * Initial state is rendered by Liquid; this keeps it in sync on variant change.
 */
class SoldOutOnly extends HTMLElement {
  connectedCallback() {
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.closest('.shopify-section, dialog')?.removeEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect
    );
  }

  /**
   * @param {ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail) return;

        const { newProduct, productId, resource } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (productId && productId !== this.dataset.productId) {
          return;
        }

        this.hidden = resource?.available !== false;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[sold-out-only] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('sold-out-only')) {
  customElements.define('sold-out-only', SoldOutOnly);
}
